import { render } from "./SveaKeyModal.vue?vue&type=template&id=6620696b&scoped=true"
import script from "./SveaKeyModal.vue?vue&type=script&lang=js"
export * from "./SveaKeyModal.vue?vue&type=script&lang=js"

import "./SveaKeyModal.vue?vue&type=style&index=0&id=6620696b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6620696b"]])

export default __exports__